import React, { Component } from 'react';
import { joinClasses } from 'components/utils/react_helper';
import { respond, DESKTOP } from '~/utils/breakpoints';

export default class CompareCta extends Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.propertiesSelected !== this.props.propertiesSelected) {
      // Moves the Zendesk widget up and down so that it doesn't
      // cover the compare button when it's displayed at the
      // bottom on mobile

      let offset = {
        horizontal: '0px',
        vertical: '0px',
        mobile: {
          horizontal: '0px',
          vertical: '0px',
        },
      };

      if (this.showButton && this.isMobile) {
        offset = {
          horizontal: '0px',
          vertical: '50px',
          mobile: {
            horizontal: '0px',
            vertical: '50px',
          },
        };
      }

      // zE isn't defined in new york locale
      if (typeof zE !== 'undefined') {
        zE('webWidget', 'updateSettings', {
          webWidget: {
            offset,
          },
        });
      }
    }
  }

  get showButton() {
    return this.props.propertiesSelected > 1;
  }

  render() {
    if (!this.showButton) {
      return null;
    }

    return (
      <div className={this.buttonClasses}>
        <div className={this.optionButtonClasses} onClick={this.props.handleCtaClick}>
          <h4 className="compare-preferences__option-button-title">
            {this.props.btnText}{' '}
            {this.props.showCount && (
              <span className="compare-preferences__option-button-count">{this.props.propertiesSelected}/3</span>
            )}
          </h4>
        </div>
      </div>
    );
  }

  get optionButtonClasses() {
    return joinClasses([
      'preferences-pane__option-button',
      'compare-preferences__option-button--default',
      this.props.active && !this.isMobile && 'compare-preferences__option-button--primary-active',
    ]);
  }

  get buttonClasses() {
    return joinClasses([
      'preferences-pane',
      'compare-preferences',
      !this.isMobile && !this.props.hideOnDesktop && 'compare-preferences--is-desktop',
      this.isMobile && !this.props.hideOnMobile && 'compare-preferences--is-mobile',
    ]);
  }

  get isMobile() {
    if (respond(DESKTOP - 1)) return false;
    return true;
  }
}
